import { compact, uniq } from 'lodash-es';
import { useEffect, useState } from 'react';

import { useOrders } from '@src/providers/OrdersProvider';
import { logger, useUserContext } from '@talos/kyoko';

import { useTradingSettings } from '@src/providers/AppConfigProvider';

export function useGroups() {
  const { enableGroups } = useTradingSettings();
  const { historicalOrders } = useOrders();
  const { orgApiEndpoint } = useUserContext();
  const [groupOptions, setGroupOptions] = useState<string[]>([]);
  useEffect(() => {
    if (orgApiEndpoint && enableGroups) {
      historicalOrders(orgApiEndpoint)
        .then(orders => {
          setGroupOptions(uniq(compact(orders.data.map(order => order.Group))));
        })
        .catch(e => {
          // This usually just happens during testing, but we can gracefully fall back to an empty array
          logger.error(e);
        });
    }
  }, [orgApiEndpoint, historicalOrders, enableGroups]);
  return groupOptions;
}
